/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { BarChart } from '@mui/x-charts';
import {
  Portlet,
  PortletContent,
  PortletHeader,
  PortletLabel,
} from 'components';
import moment from 'moment';

moment.locale('es');

export default function FPDailyAvrgChart({ title, data = [] }) {
  /**
   * 📊 Generamos los datos para el eje X.
   * Si hay datos, creamos una secuencia numérica (1, 2, 3, ...).
   * Si no hay datos, devolvemos un array vacío.
   */
  const xAxisData =
    data.length > 0
      ? data.map((item) => {
          const date = moment(String(item.date), 'YYYYMMDD');
          return `${date.date()} ${date.format('ddd')}`; // "5 Lun"
        })
      : [];

  /**
   * 📉 Generamos los valores de la serie de datos.
   * Convertimos cada `item.value` a número.
   * Si no es un número válido, usamos 0 por defecto.
   */
  const seriesData =
    data.length > 0 ? data.map((item) => parseFloat(item.value) || 0) : [];

  return (
    data.length > 0 && (
      <Portlet>
        {/* 🏷️ Encabezado del portlet con el título de la gráfica */}
        <PortletHeader noDivider={true}>
          {title ? (
            <PortletLabel title={title} />
          ) : (
            <Skeleton variant="text" width={200} height={50} />
          )}
        </PortletHeader>

        <PortletContent>
          <Box height={300} position="relative">
            {data.length > 0 ? (
              /**
               * 📊 Renderizamos el gráfico de barras si hay datos disponibles.
               */
              <BarChart
                xAxis={[
                  {
                    scaleType: 'band', // 📏 Escala de tipo banda para categorías
                    data: xAxisData, // 📌 Datos del eje X (1, 2, 3, ...)
                    barGapRatio: 1, // 📏 Espaciado entre barras
                    categoryGapRatio: 0.9, // 📏 Espaciado entre categorías
                  },
                ]}
                grid={{ horizontal: true, vertical: false }}
                series={[
                  {
                    data: seriesData, // 🔢 Datos de la serie
                    label: 'FP', // 🏷️ Etiqueta de la serie
                    color: '#00AFEF', // 🔵 Color de la serie
                  },
                ]}
                height={300} // 📏 Altura del gráfico
                borderRadius={4} // 🎨 Bordes redondeados en las barras
              />
            ) : (
              /**
               * ⏳ Mostramos un `Skeleton` si no hay datos disponibles.
               */
              <Skeleton variant="rectangular" height={400} width="100%" />
            )}
          </Box>
        </PortletContent>
      </Portlet>
    )
  );
}
